import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ListboxInput from "components/inputs/listbox"
import Import from "components/import-export/import"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import MarketLeaseTable from "components/market-lease/market-lease-table"
import Modal from 'components/modal/basic-modal'
import { WithTip } from 'components/tooltip/with-tip'
// Data
import { alphanum } from "components/table/lib/sort"
import { local, setlocal } from 'data/lib/local-json'
import api_match from "data/interface/api"
import areaMeasuresService, { Area } from 'data/area-measures'
import downtimeService, { Downtime } from 'data/downtime'
import freeRentService, { FreeRent } from 'data/free-rent'
import importService from 'data/import'
import increaseService, { Increase } from 'data/increase'
import inflationService, { Inflation } from 'data/inflation'
import marketLeaseService, { MarketLease } from 'data/market-lease'
import namedRecoveryService, { Recovery } from 'data/named-recoveries'
import payoutService, { Payout } from 'data/payout'
import propertyService, { Property } from 'data/property'
import recoveryGroupsService, { RecoveryGroup } from 'data/recovery-groups'
import recoveryPoolsService, { RecoveryPool } from 'data/recovery-pools'
import renewalProbabilityService, { RenewalProbability } from 'data/renewal-probability'
import rentrollService, { RentRoll } from 'data/rent-roll'
import rentService, { Rent } from 'data/rent'
import reportTagService, { ReportTag } from 'data/report-tag'
import tenantcapitalService, { TenantCapital } from 'data/tenant-capital'
import { ContextRow } from './market-lease-table'
import toggles from "feature-toggles"
// Styles, Icons
import { AddIcon, ShowHideIcon } from "images/icons/tools"
import { MarketLease_s } from "components/market-lease/market-lease-styles"

const tableId = "market-lease-table"

const MarketLeaseComponent: FC<RouteComponentProps> = (props) => {
  const [areaMeasures, setAreaMeasures]       = useState<Area[]>([])
  const [data, setData]                       = useState<MarketLease[]>([])
  const [downtime, setDowntime]               = useState<Downtime[]>([])
  const [rent, setRent]                       = useState<Rent[]>([])
  const [freeRent, setFreeRent]               = useState<FreeRent[]>([])
  const [increase, setIncrease]               = useState<Increase[]>([])
  const [inflation, setInflation]               = useState<Inflation[]>([])
  const [initSort, setInitSort]               = useState<boolean>(false)
  const [namedRecoveries, setNamedRecoveries] = useState<Recovery[]>([])
  const [payout, setPayout]                   = useState<Payout[]>([])
  const [property, setProperty]               = useState<Property|null>(null)
  const [propertyId, setPropertyId]           = useState(propertyService.getStoredPropertyId())
  const [recoveryGroups, setRecoveryGroups]   = useState<RecoveryGroup[]>([])
  const [recoveryPools, setRecoveryPools]     = useState<RecoveryPool[]>([])
  const [renewalProbability, setRP]           = useState<RenewalProbability[]>([])
  const [reportTags, setReportTags]           = useState<ReportTag[]>([])
  const [ti, setTI]                           = useState<TenantCapital[]>([])
  const [lc, setLC]                           = useState<TenantCapital[]>([])
  const [oc, setOC]                           = useState<TenantCapital[]>([])
  const [showColumnToggle, setShowColumnToggle] = useState<boolean>(false)
  const [showImport, setShowImport] = useState<boolean>(false)
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);

  let allCols = ['Term (Mos)', 'Downtime', 'Renewal Probability', 'Rent', 'Free Rent', 'Recovery', 'T.I.', 'L.C.', 'Other Capital', 'Sales', 'Breakpoint', 'Overage', 'Subsequent Market']
  let savedCols = local('mlColumns')
  const [columns, setColumns] = useState<string[]>(savedCols || allCols)

  useEffect(() => {

    const areaMeasuresSubscription = areaMeasuresService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAreaMeasures(init.value),
        ok    => {
          setAreaMeasures([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setAreaMeasures(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const downtimeSubscription = downtimeService.stream().subscribe(data => {
      api_match(
        data,
        init  => setDowntime(init.value),
        ok    => {
         setDowntime([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setDowntime(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const freeRentSubscription = freeRentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setFreeRent(init.value),
        ok    => {
          setFreeRent([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setFreeRent(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const importSubscription = importService.stream().subscribe(data => {
      setShowImport(data['showImport'])
    })

    setShowImport(false);


    const increaseSubscription = increaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setIncrease(init.value),
        ok    => {
          setIncrease([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setIncrease(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const marketLeaseSubscription = marketLeaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
            setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const namedRecoverySubscription = namedRecoveryService.stream().subscribe(data => {
      api_match(
        data,
        init  => setNamedRecoveries(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setNamedRecoveries([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setNamedRecoveries(ok.value)
          }
        },
        err   => {
          setNamedRecoveries(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const payoutSubscription = payoutService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPayout(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setPayout([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setPayout(ok.value)
          }
        },
        err   => {
          setPayout(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        setProperty(currentProperty);
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const recoveryGroupsSubscription = recoveryGroupsService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRecoveryGroups(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setRecoveryGroups([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setRecoveryGroups(ok.value)
          }
        },
        err   => {
          setRecoveryGroups(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const recoveryPoolsSubscription = recoveryPoolsService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRecoveryPools(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setRecoveryPools([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setRecoveryPools(ok.value)
          }
        },
        err   => {
          setRecoveryPools(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const renewalProbSubscription = renewalProbabilityService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRP(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setRP([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setRP(ok.value)
          }
        },
        err   => {
          setRP(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const rentSubscription = rentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRent(init.value),
        ok    => {
          setRent([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setRent(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const reportTagSubscription = reportTagService.stream().subscribe(data => {
      api_match(
        data,
        init  => setReportTags(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setReportTags([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setReportTags(ok.value)
          }
        },
        err   => {
          setReportTags(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const tenantcapitalSubscription = tenantcapitalService.stream().subscribe(data => {
      api_match(
        data,
        init  => {},
        ok    => {
          if(ok.value.length) {
            const tiv = _.filter(ok.value, (v) => v.type === "ti")
            const lcv = _.filter(ok.value, (v) => v.type === "lc")
            const ocv = _.filter(ok.value, (v) => v.type === "oc")
            setTI(tiv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setLC(lcv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setOC(ocv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          }
        },
        err   => {
          if(err.value.length) {
            const tiv = _.filter(err.value, (v) => v.type === "ti")
            const lcv = _.filter(err.value, (v) => v.type === "lc")
            const ocv = _.filter(err.value, (v) => v.type === "oc")
            setTI(tiv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setLC(lcv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setOC(ocv.sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          }
        },
        fetch => {}
      )
    })

    return function cleanup() {
      areaMeasuresSubscription.unsubscribe()
      downtimeSubscription.unsubscribe()
      freeRentSubscription.unsubscribe()
      importSubscription.unsubscribe()
      increaseSubscription.unsubscribe()
      inflationSubscription.unsubscribe()
      marketLeaseSubscription.unsubscribe()
      namedRecoverySubscription.unsubscribe()
      payoutSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      recoveryGroupsSubscription.unsubscribe()
      recoveryPoolsSubscription.unsubscribe()
      renewalProbSubscription.unsubscribe()
      rentSubscription.unsubscribe()
      reportTagSubscription.unsubscribe()
      tenantcapitalSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    areaMeasuresService.fetchAreaMeasures(propertyId)
    downtimeService.fetchDowntime(propertyId)
    freeRentService.fetchFreeRent(propertyId)
    increaseService.fetchIncrease(propertyId)
    inflationService.fetchInflation(propertyId)
    marketLeaseService.fetchMarketLeases(propertyId)
    namedRecoveryService.fetchNamedRecoveries(propertyId)
    payoutService.fetchPayout(propertyId)
    propertyService.fetchProperty(propertyId)
    recoveryGroupsService.fetchRecoveryGroups(propertyId)
    recoveryPoolsService.fetchRecoveryPools(propertyId)
    renewalProbabilityService.fetchRenewalProbability(propertyId)
    rentService.fetchRent(propertyId)
    reportTagService.fetchReportTags(propertyId)
    tenantcapitalService.fetchTenantcapital(propertyId, "all")

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => marketLeaseService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }


  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'marketleaseid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  const ShowHideColumns = () => {
    return (
      <a onClick={() => setShowColumnToggle(!showColumnToggle)}>
        <Isvg src={ShowHideIcon} />
      </a>
    )
  }

  const updateColumns = (val:string[]) => {
    setColumns(val);
    setlocal('mlColumns', val);
  }

  return (
    <MarketLease_s>
      <Toolbar>
        <Add />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        <ImportIcon />
        <ExportIcon template="marketlease" />
        <ShowHideColumns />
      </Toolbar>
      { showImport && <Import /> }
      { data && areaMeasures && downtime && freeRent && increase && inflation && property && payout && recoveryPools && recoveryGroups && renewalProbability && rent && reportTags && ti &&
        <MarketLeaseTable
          tableId={tableId}
          areaMeasures={areaMeasures}
          columns={columns}
          data={_data}
          downtime={downtime}
          freeRent={freeRent}
          increase={increase}
          inflation={inflation}
          namedRecoveries={namedRecoveries}
          payout={payout}
          property={property}
          recoveryGroups={recoveryGroups}
          recoveryPools={recoveryPools}
          renewalProbability={renewalProbability}
          rent={rent}
          reportTags={reportTags}
          ti={ti}
          lc={lc}
          oc={oc}
          selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}}        />
      }
      { showColumnToggle && <Modal show={showColumnToggle} title="Show/Hide Columns" toggleShow={setShowColumnToggle} width={500}>
          <ListboxInput field="columns"
            value={columns}
            options={allCols.map(column => { return {'label': column, 'value': column}})}
            persist={(field:string, val:string[]) => updateColumns(val)}
            multiple={true}
          />
      </Modal>}
    </MarketLease_s>
  )
}

export default MarketLeaseComponent
